module.exports = __webpack_public_path__ + "static/media/folder-open.7e18cabb.svg";